import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppFeatureDimKey, AppFeatureDims } from '@nk/data-entities-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppFeatureService } from '../../services/app-feature.service';

function isFeatureAccessible(features: AppFeatureDims, featureDimKey: AppFeatureDimKey): boolean {
  return features && features.flags[featureDimKey] === true;
}

@Directive({
  selector: '[nkIfFeature]',
  standalone: true,
})
export class IfFeatureDirective implements OnInit, OnDestroy {
  @Input() public nkIfFeature: AppFeatureDimKey | undefined;
  @Input() public nkIfFeatureElse: TemplateRef<unknown> | undefined;
  private _destroy$ = new Subject<void>();

  constructor(
    private _templateRef: TemplateRef<unknown>,
    private _viewContainer: ViewContainerRef,
    private _appFeatureService: AppFeatureService,
  ) {}

  public ngOnInit(): void {
    if (this.nkIfFeature) {
      // clear the view first and subscribe to check if is allowed to access
      this._viewContainer.clear();
      this._subscribeForFeatures();
    } else {
      // if key is not provided, it is assumed that feature check is not required at all
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }

  private _subscribeForFeatures(): void {
    this._appFeatureService.activeAppFeatureDimsCache
      .get()
      .pipe(takeUntil(this._destroy$))
      .subscribe((features) => {
        if (isFeatureAccessible(features, this.nkIfFeature)) {
          this._viewContainer.createEmbeddedView(this._templateRef);
        } else {
          if (this.nkIfFeatureElse) {
            this._viewContainer.createEmbeddedView(this.nkIfFeatureElse);
          } else {
            this._viewContainer.clear();
          }
        }
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
  }
}
